import { render } from "./DiagramInvocationList.vue?vue&type=template&id=b698ceb8"
import script from "./DiagramInvocationList.vue?vue&type=script&lang=js"
export * from "./DiagramInvocationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__